import _createForOfIteratorHelper from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, reactive, ref, watch } from "vue";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Cookies from "js-cookie";
export default defineComponent({
  name: "Home",
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var keepRoute = ref(["Home", "Index", "MultiColumn"]);
    var route = useRoute();
    var flag = ref(false); //菜单栏功能

    var activeIndex = ref("");
    var meunList = reactive([{
      columnName: "首页",
      apiurl: "/",
      flag: true,
      children: []
    }, // {
    //   columnName: "数据大屏",
    //   apiurl: "/dataScreens",
    //   flag: true,
    //   children: [] as Array<{ [key: string]: unknown }>,
    // },
    {
      columnName: "组织架构",
      apiurl: "/organization",
      flag: true,
      children: []
    }]);
    var arr = reactive({
      list: []
    });
    var store = useStore();
    arr.list = store.state.column.column; // 去除特殊字符

    function stripscript(s) {
      var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
      var rs = "";

      for (var i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, "");
      }

      return rs;
    } // keepRoute.value = store.state.column.urlName
    // arr.forEach((element,index) => {
    //    element.children.forEach((elem,ind)=>{
    //      if(elem.isleaf&&elem.apiurl!=''){
    //        columist(elem.apiurl,elem.param,index,arr,ind)
    //      }
    //    })
    //   });


    watch(function () {
      return route.path;
    }, function (newPath, oldPath) {
      if (newPath == "/index") {
        flag.value = true;
      } else {
        flag.value = false;
      }
    }, {
      immediate: true
    }); // if(store.state.webSocket.aWebSocket!=null){
    //    objweb();
    // }

    var beageNumber = ref(0);
    watch(function () {
      return store.state.webSocket.listlength;
    }, function (val) {
      beageNumber.value = val;
    }, {
      deep: true,
      immediate: true
    });

    function Djump() {
      // listboole.value=true
      // listlength.value = 0
      // window.open(`${process.env.VUE_APP_PCHREF}#/dashboard`);
      //  toAdmin("/dashboard")
      // toAdmin("dashboard")
      // location.href=`${process.env.VUE_APP_PCHREF}#/dashboard`;
      router.push({
        path: "/personal/TodoMessageIndex"
      }); //    window.open(, '_blank');
    } // websockett
    // let aWebSocket: any;


    var listboole = ref(true);

    function colum(_x, _x2, _x3, _x4, _x5) {
      return _colum.apply(this, arguments);
    } //请求列表栏目
    //names栏目请求接口, val参数,index数组的第几个: number子数组的第几个,lis数组,urlname下一级请求列表的接口


    function _colum() {
      _colum = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(names, val, lis, index, ind) {
        var list, culom, b;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[names](val);

              case 2:
                list = _context.sent;

                if (list.code == 0) {
                  culom = list.data;

                  for (b = 0; b < culom.length; b++) {
                    culom[b].isleaf = false;
                    culom[b].children = [];
                    culom[b].apiurl = "newsList";
                    culom[b].keyAssignments = index + 1 + "-" + (ind + 1) + "-" + (b + 1);
                    culom[b].param = {
                      columnId: culom[b].columnId,
                      pageIndex: 1,
                      pageSize: 10
                    };
                  }

                  lis.children = culom;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _colum.apply(this, arguments);
    }

    function columist(_x6, _x7, _x8, _x9, _x10, _x11, _x12, _x13) {
      return _columist.apply(this, arguments);
    }

    function _columist() {
      _columist = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(names, val, index, numbers, lis, urlname, params, ischildren) {
        var list, culomlist, i;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[names](val);

              case 2:
                list = _context2.sent;

                if (list.code == 0) {
                  culomlist = list.data;

                  for (i = 0; i < culomlist.length; i++) {
                    culomlist[i].isleaf = ischildren;
                    culomlist[i].children = [];
                    culomlist[i].apiurl = urlname;
                    culomlist[i].keyAssignments = index + 1 + "-" + (i + 1);
                    culomlist[i].param = {
                      columnId: stripscript(culomlist[i].columnId),
                      pageIndex: 1,
                      pageSize: 10
                    };
                  }

                  culomlist.forEach(function (element, ind) {
                    if (element.isleaf) {
                      colum(element.apiurl, element.param, element, index, ind);
                    }
                  });
                  lis[index].children[numbers].children = culomlist;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _columist.apply(this, arguments);
    }

    function requrelist(obj, urlname, param, ischildren) {
      //obj数组,urlname列表接口,param参数
      //栏目加子集
      for (var i = 0; i < obj.length; i++) {
        for (var j = 0; j < obj[i].children.length; j++) {
          if (obj[i].children[j].isleaf && obj[i].children[j].children.length == 0) {
            columist(obj[i].children[j].apiurl, obj[i].children[j].param, i, j, arr.list, urlname, param, ischildren);
          }
        }
      }
    }

    onBeforeRouteUpdate(function () {// if (to.path == "/multiColumn" || to.path == "/details") {
      //   keepRoute.value = ['MultiColumn'];
      // } else{
      //   keepRoute.value = ["Home",'Index'];
      // }
    });
    var params = {
      pageIndex: 1,
      pageSize: 10
    }; // newsList
    // columnList

    requrelist(arr.list, "newsList", params, false);
    store.dispatch("column/setlist", arr.list);
    arr.list.forEach(function (elemen) {
      meunList.push(elemen);
    }); //导航栏

    function loginjump(item) {
      // keepRoute.value = ["Home",'Index'];
      if ((item === null || item === void 0 ? void 0 : item.apiurl) == '/dataScreens') {
        var url = router.resolve({
          path: item.apiurl
        });
        window.open(url.href);
        return;
      }

      if (item !== null && item !== void 0 && item.apiurl) {
        router.push(item.apiurl);
      }
    } //跳转栏目分页


    function jump(val, item) {
      var key = val.keyAssignments; // keepRoute.value = ['MultiColumn'];

      if (val.isleaf) {
        key = val.children[0].keyAssignments;

        if (val.children[0].isleaf) {
          key = val.children[0].children[0].keyAssignments;
        }
      }

      router.push({
        path: "/multiColumn",
        query: {
          stair: item.keyAssignments,
          son: key
        }
      });
    }

    function enter(index) {
      activeIndex.value = index;
    }

    function leave() {
      activeIndex.value = "";
    } //切换登录或者登录


    var isLogin = ref(false);
    isLogin.value = Cookies.get("token") ? true : false;
    onBeforeRouteUpdate(function () {
      isLogin.value = Cookies.get("token") ? true : false;
    });

    function changeLogin() {
      if (isLogin.value) {
        //跳转切换登录
        router.push("/loginChange");
      } else {
        //登录
        router.push("/login");
      }
    }

    var noticeFlag = ref(false);

    var _iterator = _createForOfIteratorHelper(store.state.column.meunList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var v = _step.value;

        if (v.keyword == "Notice") {
          noticeFlag.value = v.flag;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return {
      Djump: Djump,
      activeIndex: activeIndex,
      meunList: meunList,
      enter: enter,
      leave: leave,
      isLogin: isLogin,
      changeLogin: changeLogin,
      jump: jump,
      arr: arr,
      //  store ,
      //  columist,
      loginjump: loginjump,
      columist: columist,
      colum: colum,
      requrelist: requrelist,
      keepRoute: keepRoute,
      listboole: listboole,
      // listlength,
      beageNumber: beageNumber,
      noticeFlag: noticeFlag
    };
  }
});